import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";
import jwtDecode from "jwt-decode";

import { TOKEN_NAME } from "../../../constants";
import {
  doSignIn,
  doSignUp,
} from "./thunk";

const parseToken = (token) => {
  if (!token) return undefined;
  let user;
  try {
    user = jwtDecode(token);
  } catch (e) {
    console.log(e);
  }
  return user;
};

const authSlice = createSlice({
  name: "auth",
  initialState: {
    isFetching: false,
    authenticated: !!Cookies.get(TOKEN_NAME),
    redirectUrl: null,
    userData: parseToken(Cookies.get(TOKEN_NAME)),
  },
  reducers: {
    doLogout: (state) => {
      Cookies.remove(TOKEN_NAME);
      state.authenticated = false;
    },
    setRedirectUrl: (state, action) => {
      state.redirectUrl = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(doSignIn.fulfilled, (state, action) => {
      const token = action.payload?.access_token;
      if (!!token) {
        Cookies.set(TOKEN_NAME, token);
        state.authenticated = true;
        state.userData = parseToken(token);
      }
    });
    builder.addCase(doSignUp.fulfilled, (state, action) => {
      const token = action.payload?.access_token;
      if (!!token) {
        Cookies.set(TOKEN_NAME, token);
        state.authenticated = true;
        state.userData = parseToken(token);
      }
    });
  },
});

const { actions, reducer: authReducer } = authSlice;
export const { doLogout, setRedirectUrl } = actions;
export default authReducer;
